export default __webpack_public_path__ + "static/media/Default-Profile-Picture.e81b2a28.png";